import { type UseQueryResult, useQuery } from 'react-query';
import { GrantAgreementDocumentStatusService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantAcceptanceTemplateStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const grantAcceptanceTemplateStatus = useQuery(
    ['getGrantAcceptanceTemplateStatus'],
    async () => {
      return await handleRequest(
        GrantAgreementDocumentStatusService.getApiAwardApiAppGrantAgreementDocumentStatusGrantAgreementDocumentStatusDropdown()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
            systemName: item.systemName ?? '',
          };
        });
      },
    }
  );

  return grantAcceptanceTemplateStatus;
};

export default useGetGrantAcceptanceTemplateStatus;
